import React from 'react';
import { Message } from 'semantic-ui-react';
import { formatTranslationWarning } from './TranslationWarnings';

export const hasTranslationFailure = questionaire => (
  questionaire.status === 'translation_failed'
);

export const TranslationFailure = ({ questionaire }) => {
  if (!hasTranslationFailure(questionaire)) return null;

  const failure = questionaire.translationFailure || {};
  const { location, details } = formatTranslationWarning(failure);

  return (
    <Message negative>
      <Message.Header>Translation failed</Message.Header>
      <p>{failure.message || 'The translation could not be completed.'}</p>
      <p>
        <strong>{location}</strong>
        {details && ` — ${details}`}
      </p>
      {failure.code && <p>Error code: {failure.code}</p>}
    </Message>
  );
};
